import {DOCUMENTOS_TYPES} from '../constants/documentos.types'
import { documentosInitialState } from '../initital-state/documentos.state'
import {Documentos, DocumentosAction, DocumentosState} from '../interfaces/documentos.interface'

const documentosReducer = (
  state: Documentos = documentosInitialState,
  action: DocumentosAction
): DocumentosState => {
  switch (action.type) {
    case DOCUMENTOS_TYPES.FORMDOCS_HANDLE_CHANGE:
      return {...state, otrosDocumentosAsociados: {...state.otrosDocumentosAsociados, formDoc: {...state.otrosDocumentosAsociados.formDoc, ...action.payload}}}
    case DOCUMENTOS_TYPES.FORMDOCS_SET_ERRORS:
      return {...state, otrosDocumentosAsociados: {...state.otrosDocumentosAsociados, errorDoc: {...state.otrosDocumentosAsociados.errorDoc, ...action.payload}}}
    case DOCUMENTOS_TYPES.DATADOCS_SET_ASOCIADOS:
      return {...state, otrosDocumentosAsociados: {...state.otrosDocumentosAsociados, dataDocsAsociados: action.payload}}
    case DOCUMENTOS_TYPES.DATADOCS_RESET_MODULE:
      return {...documentosInitialState, activeDoc: state.activeDoc}

    // ==== DATOS RECEPTOR =====
    case DOCUMENTOS_TYPES.DOCS_RECEPTOR_HANDLE_CHANGE:
      return {...state, datosReceptor: {...state.datosReceptor, form: {...state.datosReceptor.form, ...action.payload}}}
    case DOCUMENTOS_TYPES.DOCS_RECEPTOR_SET_ERRORS:
      return {...state, datosReceptor: {...state.datosReceptor, errors: {...state.datosReceptor.errors, ...action.payload}}}
    case DOCUMENTOS_TYPES.DOCS_RECEPTOR_RESET_MODULE:
      return {...state, datosReceptor: documentosInitialState.datosReceptor}
    case DOCUMENTOS_TYPES.DOCS_RECEPTOR_HISTORIAL_HANDLE_CHANGE:
      return {...state, datosReceptor: {...state.datosReceptor, formHistorial: {...state.datosReceptor.formHistorial, ...action.payload}}}
   
    case DOCUMENTOS_TYPES.DOCS_ACTIVE_MODULE:
      return {...state, activeDoc: action.payload}
    case DOCUMENTOS_TYPES.DOCS_SET_CATALOGO_SUCURSAL:
      return {...state, catalogoSucursal: action.payload}
    case DOCUMENTOS_TYPES.DOCS_SET_CATALOGO_SERIE:
      return {...state, catalogoSerie: action.payload}
    case DOCUMENTOS_TYPES.DOCS_FORMCLIENTE_HANDLE_CHANGE:
      return {...state, formCliente: {...state.formCliente, ...action.payload}}
    case DOCUMENTOS_TYPES.DOCS_FORMCLIENTE_SET_ERRORS:
      return {...state, errorsFormCliente: {...state.errorsFormCliente, ...action.payload}}
    case DOCUMENTOS_TYPES.DOCS_FORMPRODUCTOS_HANDLE_CHANGE:
      return {...state, formProductos: {...state.formProductos, ...action.payload}}
    case DOCUMENTOS_TYPES.DOCS_FORMPRODUCTOS_SET_ERRORS:
      return {...state, errorsFormProductos: {...state.errorsFormProductos, ...action.payload}}
    case DOCUMENTOS_TYPES.DOCS_FORMPRODUCTOS_HANDLE_CHANGE_EDIT:
      return {...state, formProductosEdit: {...state.formProductosEdit, ...action.payload}}
    case DOCUMENTOS_TYPES.DOCS_FORMPRODUCTOS_SET_ERRORS_EDIT:
      return {
        ...state,
        errorsFormProductosEdit: {...state.errorsFormProductosEdit, ...action.payload},
      }
    case DOCUMENTOS_TYPES.DOCS_FORMSUCURSAL_HANDLE_CHANGE:
      return {...state, formSucursal: {...state.formSucursal, ...action.payload}}
    case DOCUMENTOS_TYPES.DOCS_FORMSUCURSAL_SET_ERRORS:
      return {...state, errorsFormSucursal: {...state.errorsFormSucursal, ...action.payload}}
    case DOCUMENTOS_TYPES.DOCS_FORMPRODUCTOS_CLEAR:
      return {
        ...state,
        formProductos: documentosInitialState.formProductos,
        errorsFormProductos: documentosInitialState.errorsFormProductos,
      }
    case DOCUMENTOS_TYPES.DOCS_ARRAYPRODUCTOS_ADD:
      return {
        ...state,
        arrayProductos: [...state.arrayProductos, action.payload],
      }
    case DOCUMENTOS_TYPES.DOCS_ARRAYPRODUCTOS_EDIT:
      const array = state.arrayProductos.map((producto, i) =>
        i === state.productoSeleccionado ? state.formProductosEdit : producto
      )
      return {
        ...state,
        arrayProductos: array,
        modals: {...state.modals, activeEditar: false},
        formProductosEdit: documentosInitialState.formProductosEdit,
        errorsFormProductosEdit: documentosInitialState.errorsFormProductosEdit,
      }
    case DOCUMENTOS_TYPES.DOCS_ARRAYPRODUCTOS_SELECT_ONE:
      return {...state, productoSeleccionado: action.payload}
    case DOCUMENTOS_TYPES.DOCS_ARRAYPRODUCTOS_DELETE_ONE:
      return {
        ...state,
        arrayProductos: [
          ...state.arrayProductos.filter((_, i) => i !== state.productoSeleccionado!),
        ],
      }
    case DOCUMENTOS_TYPES.DOCS_ARRAYPRODUCTOS_CLEAR_ALL:
      return {...state, arrayProductos: []}
    case DOCUMENTOS_TYPES.DOCS_ARRAYPRODUCTOS_SET_CALCULOS:
      return {
        ...state,
        calculosArrayProductos: {...state.calculosArrayProductos, ...action.payload},
      }
    case DOCUMENTOS_TYPES.DOCS_FACTURACION_CLEAR_ALL:
      let datosEmisor = !action.payload ? state.datosEmisor : {}
      return {...documentosInitialState, datosEmisor}
    case DOCUMENTOS_TYPES.DOCS_SET_DATOS_EMISOR:
      return {...state, datosEmisor: {...state.datosEmisor, ...action.payload}}
    case DOCUMENTOS_TYPES.DOCS_SET_DATOS_FACTURA:
      return {...state, datosFacturaRes: {...state.datosFacturaRes, ...action.payload}}
    case DOCUMENTOS_TYPES.DOCS_SET_UUID:
      return {...state, datosUUID: {...state.datosUUID, ...action.payload}}
    case DOCUMENTOS_TYPES.DOCS_FACTURA_EMITIDA:
      return {...state, facturaEmitda: action.payload}
    case DOCUMENTOS_TYPES.DOCS_OPCIONES_ACTIVA:
      return {...state, opcionesActiva: true}
    case DOCUMENTOS_TYPES.DOCS_MODALELIMINAR_OPEN:
      return {...state, modals: {...state.modals, ...action.payload}}
    case DOCUMENTOS_TYPES.DOCS_MODALELIMINAR_CLOSE:
      return {...state, modals: documentosInitialState.modals, productoSeleccionado: null}
    case DOCUMENTOS_TYPES.DOCS_MODALFACTURACION_OPEN:
      return {...state, modals: {...state.modals, ...action.payload}}
    case DOCUMENTOS_TYPES.DOCS_MODALEDITAR_OPEN:
      return {...state, modals: {...state.modals, activeEditar: true}, ...action.payload}
    case DOCUMENTOS_TYPES.DOCS_MODALEDITAR_CLOSE:
      return {
        ...state,
        modals: {...state.modals, activeEditar: false},
        formProductosEdit: documentosInitialState.formProductosEdit,
        errorsFormProductosEdit: documentosInitialState.errorsFormProductosEdit,
      }
    case DOCUMENTOS_TYPES.DOCS_MODALIMPRESION_OPEN:
      return {...state, modals: {...state.modals, activeImpresion: action.payload}}
    case DOCUMENTOS_TYPES.DOCS_MODALEMAIL_OPEN:
      return {...state, modals: {...state.modals, activeEmail: action.payload}}
    case DOCUMENTOS_TYPES.DOCS_MODALANULAR_OPEN:
      return {...state, modals: {...state.modals, activeAnular: action.payload}}
    default:
      return state
  }
}

export default documentosReducer
